/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [{ settingsDetails: vp.SettingsDetails }, (settingsId: string) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchBillingSettingsDetails: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [settingsId, setSettingsId] = useState('');
  const [settingsDetails, setSettingsDetails] = useState({});

  useEffect(() => {
    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const { SettingsDetails } = await api.fetchBillingSettingsDetails({ SettingsID: settingsId }, source);

      if (SettingsDetails) {
        setSettingsDetails(SettingsDetails);
      }

      setDataFetchingInfo(false);
    };

    if (settingsId) void loadData();

    return () => {
      source.cancel();
    };
  }, [settingsId]);

  return [{ settingsDetails }, (_settingsId: string) => setSettingsId(_settingsId)];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchBillingSettingsDetails);
